"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedObjectLockControl = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var ComponentLabelsContext_1 = require("./ComponentLabelsContext");
var SharedObjectCheckboxControl_1 = require("./SharedObjectCheckboxControl");
/**
 * @internal
 */
exports.SharedObjectLockControl = function (_a) {
    var isLocked = _a.isLocked, isLockingSupported = _a.isLockingSupported, onLockChange = _a.onLockChange;
    var labels = ComponentLabelsContext_1.useComponentLabelsContext();
    return (react_1.default.createElement(SharedObjectCheckboxControl_1.SharedObjectCheckboxControl, { isChecked: isLocked, isSupported: isLockingSupported, onChange: onLockChange, label: labels.accessTypeLabel, name: "shared-dialog-lock", className: "s-shared-object-lock" }));
};
//# sourceMappingURL=SharedObjectLockControl.js.map